import { render, staticRenderFns } from "./EmptyCampaign.vue?vue&type=template&id=3b24c992&scoped=true&"
import script from "./EmptyCampaign.vue?vue&type=script&lang=js&"
export * from "./EmptyCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCampaign.vue?vue&type=style&index=0&id=3b24c992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24c992",
  null
  
)

export default component.exports